import React, { useState, useEffect, memo } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./css/default.css";
import image_logo from "./img/logo_ag.png";
import { jwtDecode } from "jwt-decode";
//import { wait } from "@testing-library/user-event/dist/utils";
//import { decode as base64_decode, encode as base64_encode } from "base-64";

function Login() {
    ///////////////////
    const [flag] = useState(window.encodeScript("webApp"));
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [sso_user_ag, setSsoUser] = useState("");
    const navigate = useNavigate();
    
    useEffect(() => {
        const token = new URLSearchParams(window.location.search).get("tokens");
        // if (token != null) {
        //     const userInfo = jwtDecode(token);
        //     //console.log("Thông tin người dùng từ JWT:", userInfo);
        //     window.saveToStorage("user-info", JSON.stringify(userInfo));
        //     window.indexDB.initDB(userInfo.id).then(); //() => console.log("✅ IndexedDB đã khởi tạo!"));
        //     navigate("/votes");
        // } else if (window.getFromStorage("user-info") && window.getFromStorage("user-info") !== "null") {
        //     navigate("/votes");
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    async function getTimeCurrentServer() {
        let flags = { flag };
        let result = await fetch(global.config.url.api + "login/getTime", {
            method: "POST",
            body: JSON.stringify(flags),
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        });
        result = await result.json();
        if (result.code === 200) {
            return result.time;
        } else return false;
    }
    async function login(event) {
        //Prevent page reload
        event.preventDefault();
        const timeCurrent = await getTimeCurrentServer();
        const rawValue = new URLSearchParams(window.location.search).get("id");
        if (timeCurrent) {
            const d = window.encodeScript(email + "<+>" + password + "<+>" + timeCurrent + "<+>" + rawValue);
            let item = { d };
            let result = await fetch(global.config.url.api + "login", {
                method: "POST",
                body: JSON.stringify(item),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            });
            result = await result.json();
            if (result.code === 200) {
                window.saveToStorage("user-info", JSON.stringify(result.data));
                window.indexDB.initDB(result.data.id).then(); //() => console.log("✅ IndexedDB đã khởi tạo!"));
                navigate("/results");
            }
            if (result.code === 201) {
                toast.error(result.msg);
            }
        }
    }
    const handleLogin = () => {
        window.location.href = global.config.url.api + "login/redirectAG";
    };
    //////////log-out////////////
    return (
        <div className="wrappers fadeInDown">
            <div className="sidebar sidebar_login">
                <div className="logo">
                    <img src={image_logo} alt="" />
                </div>
                <div className="comp-name">
                    <div className="name">
                        Trung tâm Chuyển đổi số <br></br> An Giang
                        {/* <br />
                        thông tin và truyền thông */}
                    </div>
                    <div className="local"> </div>
                </div>
                <div className="info">
                    <p>
                        <strong>Thông tin liên hệ:</strong>
                    </p>
                    <p>
                        <i className="fas fa-home"></i> - Số 17, Phan Bội Châu, phường Rạch Giá, tỉnh An Giang
                    </p>
                    <p>
                        <i className="fas fa-phone"></i> - 02973.680.680
                    </p>
                    <p className="webs">
                        <a target="_blank" href="https://dx.aggdxcenter.com">
                            <i className="fas fa-globe"></i> - dx.aggdxcenter.com
                        </a>
                    </p>
                    <p>
                        <i className="fas fa-envelope"></i> - dxcenter.skhcn@angiang.gov.vn{" "}
                    </p>
                </div>
            </div>
            <div id="formContent">
                <form onSubmit={(e) => login(e)}>
                    <div className="fadeIn first mb-2 text-primary font-weight-bold h5 mb-4">
                        {/* <i className="fas fa-sign-in-alt mr-3"></i>  */}
                        YÊU CẦU ĐĂNG NHẬP
                    </div>
                    <input type="text" id="login" className="fadeIn second login_input mb-2" defaultValue={email} onChange={(e) => setEmail(e.target.value)} placeholder="Nhập tên đăng nhập" />
                    <br />
                    <input type="password" id="password" className="fadeIn third login_input mb-2" onChange={(e) => setPassword(e.target.value)} placeholder="Nhập mật khẩu" />
                    <br />
                    <button onClick={(e) => login(e)} className="btn fadeIn fourth login_submit btn-primary">
                        <i className="fas fa-sign-in-alt mr-3"></i>
                        <b>Đăng nhập</b>
                    </button>
                </form>
                <span className="text-primary">Hoặc</span>
                <br />
                <button onClick={handleLogin} className="btn fadeIn fourth login_sso btn-danger">
                    <i className="fas fa-sign-in-alt mr-3"></i>
                    Đăng nhập bằng Mail An Giang
                </button>
                {/* <button onClick={(e) => login_sso_form_vneid(e)} className="btn fadeIn fourth login_sso btn-info">
                    <i className="fas fa-sign-in-alt mr-3"></i>
                    Đăng nhập bằng tài khoản VNeID
                </button> */}
            </div>
            <ToastContainer />
        </div>
    );
}
export default memo(Login);
